import type { PlayerStore } from '../store/playerStore';

export function isPlayerCameraUpdateBlocked(store: PlayerStore): boolean {
  return store.state.camera.gizmoDragging;
}

export function isPlayerCharacterFitBlocked(store: PlayerStore): boolean {
  return store.isPlayerCharacterFitBlocked();
}
